import { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function NotificationBar({ onHeightChange }) {
  const [notification, setNotification] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
  async function fetchNotification() {
  try {
  const res = await fetch(`${API_URL}/api/notification`);
  if (!res.ok) return;
  const data = await res.json();
  if (data && data.id) {
  const dismissedId = sessionStorage.getItem('flynaut_notif_dismissed');
  if (dismissedId === data.id) return;
  setNotification(data);
  setVisible(true);
  }
  } catch {
  // Silent fail - notification bar is optional
  }
  }
  fetchNotification();
  }, []);

  useEffect(() => {
  if (visible && !dismissed && onHeightChange) {
  onHeightChange(36);
  } else if (onHeightChange) {
  onHeightChange(0);
  }
  }, [visible, dismissed, onHeightChange]);

  if (!notification || dismissed) return null;

  const handleDismiss = (e) => {
  e.preventDefault();
  e.stopPropagation();
  sessionStorage.setItem('flynaut_notif_dismissed', notification.id);
  setDismissed(true);
  };

  const bgClass = notification.style === 'navy' ? 'bg-[#1A202C]' : 'bg-[#F5841F]';

  return (
  <div
  data-testid="notification-bar"
  className={`${bgClass} text-white fixed top-0 left-0 right-0 z-[1001] transition-transform duration-200 ease-out`}
  style={{ height: '36px' }}
  >
  <div className="max-w-content mx-auto px-6 h-full flex items-center justify-center relative">
  <a
  href={notification.link_url}
  data-testid="notification-link"
  className="text-white text-sm font-medium hover:underline truncate pr-8"
  >
  {notification.message}
  </a>
  <button
  onClick={handleDismiss}
  data-testid="notification-dismiss"
  className="absolute right-6 text-white/70 hover:text-white transition-colors"
  aria-label="Dismiss notification"
  >
  <X size={16} />
  </button>
  </div>
  </div>
  );
}
